 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		11: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"eb3625836bafedb51a71d167e5c0ea317e3c0438","2":"3c4b8beafce7e8f83fdc018ce953e02e00bc3b15","3":"b637e9a5","4":"204ef6dd3fb38e15b5bbd2f90e87d9bc12ed73e0","5":"cf063f1b574a9e78802595c48e880aa27f552ee9","6":"2f5ceedb6e700d27de9df7e9e1d99d8eddac36fc","7":"44dff039c7278d73fea09a710dddef86b2f7a16f","8":"ea88be26","9":"eb3124a381ef3ab30c8a7b10e52f69c3f82382ff","10":"b774f40ad492a1ee3a5cd53939f70f047d9f6166","12":"801a6084","14":"component---cache-caches-gatsby-plugin-offline-app-shell-js","15":"component---src-pages-404-js","16":"component---src-pages-blog-js","17":"component---src-pages-chi-siamo-jsx","18":"component---src-pages-contatti-jsx","19":"component---src-pages-index-jsx","20":"component---src-pages-informative-cookie-policy-jsx","21":"component---src-pages-informative-privacy-candidati-jsx","22":"component---src-pages-informative-privacy-clienti-jsx","23":"component---src-pages-informative-privacy-jsx","24":"component---src-pages-informative-privacy-policy-jsx","25":"component---src-pages-lavora-con-noi-account-executive-jsx","26":"component---src-pages-lavora-con-noi-account-web-project-manager-jsx","27":"component---src-pages-lavora-con-noi-backend-developer-jsx","28":"component---src-pages-lavora-con-noi-frontend-developer-jsx","29":"component---src-pages-lavora-con-noi-jsx","30":"component---src-pages-lavora-con-noi-web-developer-stage-jsx","31":"component---src-pages-lavora-con-noi-wordpress-developer-jsx","32":"component---src-pages-projects-aiti-jsx","33":"component---src-pages-projects-enternow-jsx","34":"component---src-pages-projects-jsx","35":"component---src-pages-projects-materica-jsx","36":"component---src-pages-projects-navigando-jsx","37":"component---src-pages-projects-pathlog-jsx","38":"component---src-pages-projects-petra-jsx","39":"component---src-pages-projects-vega-jsx","40":"component---src-pages-projects-ycj-jsx","41":"component---src-pages-servizi-jsx","42":"component---src-templates-index-js"}[chunkId]||chunkId) + "-" + {"0":"74013591e2d3ba7bf297","1":"ebd2d40ad007ba8a2799","2":"63386c1d466bb75b01e4","3":"c58567401d3aff88478b","4":"c9f4caad2349599b158c","5":"fe1d9db22eff617850db","6":"da3109878140805ab87e","7":"8cd29a7bcd280ed3a46e","8":"e3fb2a57bfd99481abe2","9":"1d8ef99d4363319ee2ac","10":"5c9dea4292558d8e6bb0","12":"e8dc9bd7c47962189be1","14":"19c1ed8dac23de853453","15":"f673e178cfee684a5d66","16":"242c87e31df89a993b3a","17":"d3f1c9ed68654dabbf87","18":"b992dec4bb1fa97b099e","19":"7a4ea1cb1521bdf1b790","20":"80ae7200b4e9be582c1d","21":"dcc6e2074017e19bf28f","22":"faeed985707f4568272d","23":"c0d236e8d287467233b0","24":"1ea46d5541ecd5b9c36c","25":"c3375b7ebd91e86caf97","26":"3b44d5edfc072aa90c6d","27":"8e4d00fe73391e78135b","28":"824d6bcdb10cf8b5362e","29":"23d6c7b1494db16af2c8","30":"686369a14a491921b482","31":"e85586e0837daf9e7168","32":"862c888ad73fc305ed22","33":"21e7e6cc1618540aaf24","34":"a93894d548004b97c1be","35":"b7ccf0b88a84d968ed99","36":"2f83250c5bd998d7049d","37":"10f31d433f941f8f519d","38":"5a3d07132fea9353de4e","39":"019e818e995592b6dc0b","40":"46e5afde769371f76e99","41":"63737257d8f35e2397e0","42":"9776c5fdcfdc23b62976"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"eb3625836bafedb51a71d167e5c0ea317e3c0438","2":"3c4b8beafce7e8f83fdc018ce953e02e00bc3b15","3":"b637e9a5","4":"204ef6dd3fb38e15b5bbd2f90e87d9bc12ed73e0","5":"cf063f1b574a9e78802595c48e880aa27f552ee9","6":"2f5ceedb6e700d27de9df7e9e1d99d8eddac36fc","7":"44dff039c7278d73fea09a710dddef86b2f7a16f","8":"ea88be26","9":"eb3124a381ef3ab30c8a7b10e52f69c3f82382ff","10":"b774f40ad492a1ee3a5cd53939f70f047d9f6166","12":"801a6084","14":"component---cache-caches-gatsby-plugin-offline-app-shell-js","15":"component---src-pages-404-js","16":"component---src-pages-blog-js","17":"component---src-pages-chi-siamo-jsx","18":"component---src-pages-contatti-jsx","19":"component---src-pages-index-jsx","20":"component---src-pages-informative-cookie-policy-jsx","21":"component---src-pages-informative-privacy-candidati-jsx","22":"component---src-pages-informative-privacy-clienti-jsx","23":"component---src-pages-informative-privacy-jsx","24":"component---src-pages-informative-privacy-policy-jsx","25":"component---src-pages-lavora-con-noi-account-executive-jsx","26":"component---src-pages-lavora-con-noi-account-web-project-manager-jsx","27":"component---src-pages-lavora-con-noi-backend-developer-jsx","28":"component---src-pages-lavora-con-noi-frontend-developer-jsx","29":"component---src-pages-lavora-con-noi-jsx","30":"component---src-pages-lavora-con-noi-web-developer-stage-jsx","31":"component---src-pages-lavora-con-noi-wordpress-developer-jsx","32":"component---src-pages-projects-aiti-jsx","33":"component---src-pages-projects-enternow-jsx","34":"component---src-pages-projects-jsx","35":"component---src-pages-projects-materica-jsx","36":"component---src-pages-projects-navigando-jsx","37":"component---src-pages-projects-pathlog-jsx","38":"component---src-pages-projects-petra-jsx","39":"component---src-pages-projects-vega-jsx","40":"component---src-pages-projects-ycj-jsx","41":"component---src-pages-servizi-jsx","42":"component---src-templates-index-js"}[chunkId]||chunkId) + "." + {"0":"9ba2e4d2a544bcd1218a","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
